import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.createMessageModal;

const makeSelectOpen = createDraftSafeSelector(selectState, (state) => state.open);
const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);

const makeSelectContractorId = createDraftSafeSelector(selectState, (state) => state.contractorId);
const makeSelectLeadId = createDraftSafeSelector(selectState, (state) => state.leadId);

export { selectState, makeSelectOpen, makeSelectLoading, makeSelectContractorId, makeSelectLeadId };
